import React from 'react';
import { CreateChancel } from 'components';
import { useModal } from 'utils';
import { scheduleModalsStyle } from './styles';

/** Asks before saving a service appt (or series) with no staff — it stays "Unassigned" until staff is assigned. */
export const UnassignedConfirm = ({ handleSubmit, multiple, isEdit }) => {
    const classes = scheduleModalsStyle();
    const { close } = useModal();
    const what = multiple ? 'These recurring appointments' : 'This appointment';

    return (
        <div className={classes.lockUnlockWrapper}>
            <p className={classes.confirmTitle}>{isEdit ? 'Save appt without staff?' : `Create ${multiple ? 'appts' : 'appt'} without staff?`}</p>
            <p className={classes.confirmSubTitle}>
                {`${what} will be ${isEdit ? 'saved' : 'created'} without an assigned staff member. You can assign staff later.`}
            </p>
            <CreateChancel
                create={isEdit ? 'Save Without Staff' : 'Create Without Staff'}
                chancel={'Go Back'}
                onCreate={handleSubmit}
                onClose={() => close()}
                buttonWidth="223px"
                createButnMargin={'16px'}
            />
        </div>
    );
};
